// Mirror FE del catalogo voci (presentazione). Le CHIAVI devono restare allineate
// al backend (#modules/auth/menuCatalog.js); il backend resta autorevole.
import {
	AppstoreOutlined,
	ClusterOutlined,
	TagOutlined,
	FileAddOutlined,
	DeploymentUnitOutlined,
	PictureOutlined,
	ThunderboltOutlined,
	SettingOutlined,
	TeamOutlined
} from "@ant-design/icons";

// Si memorizza il COMPONENTE icona (non l'elemento) per restare in un .js senza JSX.
export const MENU_PRESENTATION = [
	{key: "dashboard", Icon: AppstoreOutlined, label: "Dashboard", route: "/"},
	{key: "org", Icon: ClusterOutlined, label: "Organizzazione", route: "/org"},
	{key: "promos", Icon: TagOutlined, label: "Promo", route: "/promos"},
	{key: "flyers", Icon: FileAddOutlined, label: "Volantini", route: "/flyers"},
	{key: "cards", Icon: DeploymentUnitOutlined, label: "Cards", route: "/cards"},
	{key: "webp", Icon: PictureOutlined, label: "WebP Tool", route: "/webp"},
	{key: "logs", Icon: ThunderboltOutlined, label: "Realtime/Log", route: "/logs"},
	{key: "settings", Icon: SettingOutlined, label: "Impostazioni", route: "/settings"},
	{key: "users", Icon: TeamOutlined, label: "Gestione Utenti", route: "/users"}
];

export const MENU_KEYS = MENU_PRESENTATION.map(m => m.key);
export const ROUTE_MAP = Object.fromEntries(MENU_PRESENTATION.map(m => [m.key, m.route]));

// Rotta → voce richiesta (incl. sotto-rotte senza voce a menu propria).
export function requiredMenuForPath(pathname)
{
	if (pathname === "/") return "dashboard";
	if (pathname.startsWith("/org")) return "org";
	if (pathname.startsWith("/promos")) return "promos";
	if (
		pathname.startsWith("/flyers") ||
		pathname.startsWith("/flyermanage") ||
		pathname.startsWith("/flyerpreprocess") ||
		pathname.startsWith("/variant-preprocess")
	) return "flyers";
	if (pathname.startsWith("/cards")) return "cards";
	if (pathname.startsWith("/webp")) return "webp";
	if (pathname.startsWith("/logs")) return "logs";
	if (pathname.startsWith("/settings")) return "settings";
	if (pathname.startsWith("/users")) return "users";
	return null;
}

// Chiave usata per evidenziare la voce attiva nel menu.
export function pathKeyForPath(pathname)
{
	return requiredMenuForPath(pathname) || "dashboard";
}
